import { loadSettingsPrefs } from "./settingsPrefsStorage";

/** The five text sizes, as a percent of the browser's own size (the styles are in rem). */
export const TEXT_SIZES = [90, 100, 115, 130, 150];

/** The step closest to a saved percent (older versions saved any value from 90 to 115). */
export function textSizeStep(percent) {
    const value = Number(percent) || 100;
    return TEXT_SIZES.reduce(
        (best, size, i) => (Math.abs(size - value) < Math.abs(TEXT_SIZES[best] - value) ? i : best),
        1
    );
}

/** Sizes the whole site's text. */
export function applyTextSize(percent) {
    document.documentElement.style.fontSize = `${TEXT_SIZES[textSizeStep(percent)]}%`;
}

/** Applies the saved size; called once when the site starts. */
export function applySavedTextSize() {
    applyTextSize(loadSettingsPrefs().fontScale);
}
